import { Gallery, mainRef } from './Gallery';

export default Gallery;
export { mainRef as ref };
export type { TypeGalleryProps } from './types';
